import {
  TiVoAppDetailsManifestsTab,
  TiVoAppDetailsVariantTab,
  TiVoAppDetailsProviderTab,
  TiVoAppDetailsPublicationsTab,
  TiVoAppDetailsVariantsTab,
} from "./tabs";

/*
 * Section texts
 */

export const TEXTS = {
  SHARED: {
    ALL_COUNTRIES_LABEL: "all",
    DISABLED_LABEL: "Disabled",
    ENABLED_LABEL: "Enabled",
    IMAGES_SECTION_HEADER: "Images",
    NO_IMAGES_MESSAGE: "No images are available.",
    PUBLICATION_WARNING_MESSAGE:
      "Promoting this variant will result in unpublishing it from the following #{level}: #{items}.",
  },
  PROVIDER: {
    NAME: "Provider",
    ACR_RIGHTS_SUBS_HEADER: "Do we have ACR rights?",
    AGREEMENT_MODEL_SUBS_HEADER: "Commercial agreement type",
    AGREEMENT_SUMMARY_SUBS_HEADER: "Commercial agreement summary",
    AGREEMENTS_SECTION_HEADER: "Contract summary",
    ALLOW_LIST_SECTION_HEADER: "Allow list",
    ALLOW_LIST_TOOLTIP:
      "List of domains, in form of regular expressions, that are associated with this Provider app or set of apps. This is used in Automotive only, since many Car OEMs don't allow all domains to be opened in their browser hence they need an explicit list",
    APP_CATEGORY_SUBS_HEADER: "App category",
    APP_LABEL_SUBS_HEADER: "App label",
    APP_LABEL_TOOLTIP:
      "A short name to be used internally in this dashboard to refer to this provider. It will not be visible to end users",
    ASSIGNEES_HEADER: "Internal stakeholders",
    ASSIGNEES_BDM: "Business Owner (BD)",
    ASSIGNEES_TAM: "Technical Account Manager (TAM)",
    BASIC_DETAILS_SECTION_HEADER: "App info",
    CONTRACT_ORIGIN_SUBS_HEADER: "Contract origin",
    CONTRACT_STATUS_SUBS_HEADER: "Contract status",
    COUNTRIES_SECTION_HEADER: "Approved countries",
    CSP_BIZ_MODEL_SUBS_HEADER: "CSP business model",
    CSP_SUPPORT_SECTION_HEADER: "Support info",
    CSP_GROUP_SUSB_HEADER: "CSP group",
    DEAL_AND_OBLIGATIONS_HEADER: "Obligations summary",
    DEAL_SUMMARY_SUBS_HEADER: "Deal summary",
    DISPLAY_NAME: "Display name",
    DISPLAY_NAME_TOOLTIP:
      "This is the name that will be used to represent the App in various UI element. This name will be visible to end users on devices",
    HEADER: "Provider",
    JW_PROVIDER_ID_SUBS_HEADER: "JW Provider ID",
    JW_PROVIDER_ID_TOOLTIP:
      "A unique ID that represents this provider within the Just Watch catalog. Just Watch is a 3rd party providing metadata to TiVo",
    NO_DEAL_SUMMARY_MESSAGE: "The deal summary is not available.",
    PLACEMENT_OBLIGATIONS_SUBS_HEADER: "Placement obligations",
    PROMO_OBLIGATIONS_SUBS_HEADER: "Promotion obligations",
    PROVIDER_EDIT_BUTTON: "Edit provider",
    PROVIDER_ID_SUBS_HEADER: "Provider ID",
    PROVIDER_ID_TOOLTIP:
      "A unique ID that represents this provider within the TiVo OS ecosystem (both TV and Car). This ID is used e.g. to associate this provider with their catalog (movies, shows) ingested via a different system, or to identify this provider in analytics system. Typically, this is the same as the app name",
    REG_EXP_COL_HEADER: "Regular expression",
    REPORTING_OBLIGATIONS_SUSB_HEADER: "Reporting obligations",
    REQUIRES_CONFIRMATION_SUBS_HEADER:
      "Requires CSP approval before publication",
    SUPPORT_CONTACTS_SUBS_HEADER: "Additional contacts",
    SUPPORT_EMAIL_SUBS_HEADER: "Support email",
    SUPPORT_NOTES_SUBS_HEADER: "Support notes",
    SUPPORT_PHONE_SUBS_HEADER: "Support phone",
    SUPPORT_PRIORITY_SUBS_HEADER: "Support priority",
    SUPPORT_SLA_SUBS_HEADER: "Support SLA",
    UNIVERSAL_PROVIDER_ID_SUBS_HEADER: "Universal provider ID",
    UNIVERSAL_PROVIDER_ID_TOOLTIP:
      "A unique ID that represents this provider within the entire TiVo ecosystem (TV, Car and PayTV). Typically, this is the same as the app name and in most cases is the same as the Provider ID above, except when the Provider ID has some legacy naming.",
  },
  MANIFESTS: {
    NAME: "Manifests",
  },
  PRESENTATION: {
    NAME: "Presentations",
    ASPECT_RATIO_SUBS_HEADER: "Aspect ratio",
    ATTRS_SUBS_HEADER: "Attributes",
    CONFIGS_SECTION_HEADER: "Configurations",
    DEFAULT_CONFIG_LABEL: "Default",
    FEATURE_COL_HEADER: "Feature",
    LABEL_COL_HEADER: "Name",
    LABEL_SUBS_HEADER: "Label",
    MATCH_BY_COUNTRIES_SUBS_HEADER: "Match by countries",
    MATCH_BY_FEATURES_SUBS_HEADER: "Match by features",
    PARTNER_PICKS_SECTION_HEADER: "Partner picks",
    REPORTING_SUBS_HEADER: "Reporting",
    TYPE_SUBS_HEADER: "Type",
    VALUE_COL_HEADER: "Value",
  },
  PUBLICATIONS: {
    NAME: "Publications",
    CLIENT_TYPE_COL: "Client type",
    OEM_COL: "Oem",
    ERROR_HEADER: "Something went wrong",
    EDIT_TAB: "Edit",
    SUMMARY_TAB: "Summary",
    UNKNOWN_OEM: "Unknown OEM",
  },
  VARIANT: {
    NAME: "Variant",
    AD_PARAMS_TEMPLATE_SUBS_HEADER: "Ad parameters template",
    ADS_SECTION_HEADER: "Ads enabled",
    ALT_PLAYBACK_URI_SUBS_HEADER: "Alternative playback URI",
    APP_TYPE_SUBS_HEADER: "App type",
    APPEND_URL_PARAMS_SUBS_HEADER: "Append URL parameters",
    ATTRS_SECTION_HEADER: "Launch configuration",
    ATTRS_WITH_CRITERIA_SUBS_HEADER: "Attributes with criteria",
    BASIC_SECTION_HEADER: "Basic",
    CLASS_NAME_SUBS_HEADER: "Class name",
    HEADER: "Variant",
    INTENT_SUBS_HEADER: "Intent",
    KEY_COL_HEADER: "Key",
    MISSING_IMAGES_WARNING:
      "Production images are required for RS3 promotion. You may proceed now, but RS3 promotion will be blocked until production images are uploaded.",
    NAME_COL_HEADER: "Name",
    NAME_VALUE_MAP_SUSB_HEADER: "Name value map",
    PLAYBACK_URI_SUBS_HEADER: "Playback URI",
    PROCEED_BUTTON: "Proceed anyway",
    PLACEMENT_COL_HEADER: "Placement",
    PROMOTE_AND_PUBLISH_BUTTON_LABEL: "Promote & Publish on #{releaseStage}",
    PROMOTE_BUTTON_LABEL: "Promote to #{releaseStage}",
    PROMOTE_CONFIRM_UNPUBLISHING_DESCRIPTION:
      "This variant will be unpublished from all targets that have been removed. Do you want to continue?",
    PROMOTE_CONFIRM_UNPUBLISHING_NO: "Cancel",
    PROMOTE_CONFIRM_UNPUBLISHING_TITLE: "Confirm unpublishing",
    PROMOTE_CONFIRM_UNPUBLISHING_YES: "Continue",
    PUBLISHING_CONFIRMATION_CANCEL: "Cancel",
    PUBLISHING_CONFIRMATION: "Do you want to promote and publish anyway?",
    PUBLISHING_CONFIRMATION_PROCEED: "Promote & Publish",
    PROVIDER_OVERWRITES_HEADER: "Provider overwrites",
    STATUS_SUBS_HEADER: "Status",
    SUBMITTED_TAB_LABEL: "Submitted",
    TARGET_SUBS_HEADER: "Target",
    UPLOAD_MISSING_IMAGES: "Upload missing images",
    URI_TRANSFORM_SECTION_HEADER: "URI transform",
    VALUE_COL_HEADER: "Value",
    VARIANT_EDIT_BUTTON: "Replace & edit draft",
    VARIANT_LABEL_SUBS_HEADER: "Variant label",
    INHERITED_COUNTRIES: "Countries are inherited from provider",
  },
  VARIANTS: {
    NAME: "Variants",
    HEADER: "Variants",
    ADD_NEW_VARIANT_BUTTON: "Add new variant",
    CREATION_DATE_COL_HEADER: "Creation date",
    STATUS_COL_HEADER: "Status",
  },
  ZOOM_CONFIG: {
    HEADER: "Zoom configuration",
    ZOOM_FACTOR_SUBS_HEADER: "Zoom factor",
    ZOOM_FACTOR_RATIO_SUBS_HEADER: "Zoom factor ratio",
    NO_ZOOM_CONFIGS_MESSAGE: "No zoom configurations are available.",
  },
};

/*
 * Tabs
 */

export const TABS = {
  APPLICATION: {
    path: "application",
    text: TEXTS.PROVIDER.NAME,
    dataTestId: "application-tab",
    Component: TiVoAppDetailsProviderTab,
  },
  MANIFESTS: {
    path: "manifests",
    text: TEXTS.MANIFESTS.NAME,
    dataTestId: "manifests-tab",
    Component: TiVoAppDetailsManifestsTab,
  },
  PUBLICATIONS: {
    path: "publications",
    text: TEXTS.PUBLICATIONS.NAME,
    dataTestId: "publications-tab",
    Component: TiVoAppDetailsPublicationsTab,
  },
  VARIANT: {
    path: "variant",
    text: TEXTS.VARIANT.NAME,
    dataTestId: "variant-tab",
    Component: TiVoAppDetailsVariantTab,
  },
  VARIANTS: {
    path: "variants",
    text: TEXTS.VARIANTS.NAME,
    dataTestId: "variants-tab",
    Component: TiVoAppDetailsVariantsTab,
  },
};

/*
 * Headers
 */

export const IMAGE_SUBSECTION_HEADERS = {
  "*": "Other images",
  square: "Square logo",
  wide: "Wide logo",
  rectangle: "Rectangular logo",
  atmospheric: "Rectangular logo",
};
